export default __webpack_public_path__ + "static/media/bag.6e99dab5.svg";